import { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";

export function ChangePasswordDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };

  const save = async () => {
    if (next.length < 6) return toast.error("La nuova password deve avere almeno 6 caratteri");
    if (next !== confirm) return toast.error("Le due password non coincidono");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password aggiornata");
      setOpen(false);
      reset();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) reset(); }}>
      <div onClick={() => setOpen(true)}>{trigger}</div>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-primary" /> Cambia Password</DialogTitle>
          <DialogDescription>Aggiorna la password del tuo account.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label htmlFor="cp">Password attuale</Label>
            <Input id="cp" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="current-password-input" autoComplete="current-password" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="np">Nuova password</Label>
            <Input id="np" type="password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="new-password-input" autoComplete="new-password" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="cnp">Conferma nuova password</Label>
            <Input id="cnp" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="confirm-password-input" autoComplete="new-password" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={saving} data-testid="change-password-save-btn">
            {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null} Aggiorna Password
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
